import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { expandedInboxWithSizeMediumState } from 'store/atoms'
import styles from './AppointmentRequisitions.module.sass'

const AppointmentRequisitions = (props) => {
	const { data, ...attributes } = props
	const expandedInboxMedium = useRecoilValue(expandedInboxWithSizeMediumState)

	const mappedRequisitions = useMemo(
		() =>
			data.requisitions.map((requisition) => {
				return (
					<VStack
						key={requisition?.id}
						className={styles['medicalActs-container']}
					>
						<SlidingText>
							<strong>
								{requisition?.type?.name} #{requisition?.id}
							</strong>
						</SlidingText>
						{requisition?.medicalActs?.map((medicalAct) => {
							return (
								<SlidingText
									key={medicalAct?.id}
									className={styles['medicalAct-name']}
								>
									<small>
										{medicalAct?.executedQuantity}/
										{medicalAct?.approvedQuantity} (
										{medicalAct?.requestedQuantity}){' '}
										<strong>{medicalAct?.code}</strong>{' '}
										{medicalAct?.name}
									</small>
								</SlidingText>
							)
						})}
					</VStack>
				)
			}),
		[data.requisitions]
	)

	return (
		<div className={styles['requisitions-container']}>
			<h5>{data.$cardLabels?.requisitions}</h5>
			<VStack
				{...attributes}
				className={`${styles['requisitions']} ${
					expandedInboxMedium && styles['--inbox-open']
				}`}
			>
				{mappedRequisitions}
			</VStack>
		</div>
	)
}

export default AppointmentRequisitions
